import {Button, Snackbar} from '@material-ui/core'
import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { PaymentElement } from '@stripe/react-stripe-js';
import {useStripe, useElements } from '@stripe/react-stripe-js';

const CheckoutForm = ({submitFormHandler, paymentDone, handleSubmit}) => {
    const stripe = useStripe();
    const elements = useElements();
    const [open, setOpen] = React.useState(false);
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const onCheckoutHandler = async ()=> {
        if (!stripe || !elements || isSubmitting) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setIsSubmitting(true);
        try {
            const payResult = await stripe.confirmPayment({
                elements,
                redirect: 'if_required',
            });

            if (payResult.error) {
                setOpen(payResult.error.message);
                return;
            }

            const paymentIntent = payResult.paymentIntent;
            if (!paymentIntent || paymentIntent.status !== 'succeeded') {
                setOpen('Payment has not completed. Please try again.');
                return;
            }

            let appointmentCreated = false;
            await handleSubmit(async (formData) => {
                appointmentCreated = await submitFormHandler(
                    formData,
                    paymentIntent.id
                );
            })();
            if (appointmentCreated) {
                paymentDone(paymentIntent.id);
            }
        } catch {
            setOpen('Unable to confirm payment. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    }


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
        return;
        }

        setOpen(false);
    };

    return (
        <>
            <PaymentElement />
            <Button onClick={onCheckoutHandler} variant="outlined" fullWidth disabled={!stripe || !elements || isSubmitting} style={{marginTop: 26}}>Pay Now</Button>

            <Snackbar
                severity="warning"
                elevation={6} 
                variant="filled"
                anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
                }}
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message={open}
                action={
                <React.Fragment>
                    <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                    <CloseIcon fontSize="small" />
                    </IconButton>
                </React.Fragment>
                }
            />
        </>

    );
};

export default CheckoutForm;